export function TextIllegalIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6667 8.75008V5.66675C16.6667 4.26662 16.6667 3.56655 16.3942 3.03177C16.1545 2.56137 15.7721 2.17892 15.3017 1.93923C14.7669 1.66675 14.0668 1.66675 12.6667 1.66675H7.33334C5.93321 1.66675 5.23315 1.66675 4.69837 1.93923C4.22796 2.17892 3.84551 2.56137 3.60583 3.03177C3.33334 3.56655 3.33334 4.26662 3.33334 5.66675V14.3334C3.33334 15.7335 3.33334 16.4336 3.60583 16.9684C3.84551 17.4388 4.22796 17.8212 4.69837 18.0609C5.23315 18.3334 5.93321 18.3334 7.33334 18.3334H9.58334M18.3333 18.3334L17.0833 17.0834M17.9167 15.0001C17.9167 16.6109 16.6108 17.9167 15 17.9167C13.3892 17.9167 12.0833 16.6109 12.0833 15.0001C12.0833 13.3893 13.3892 12.0834 15 12.0834C16.6108 12.0834 17.9167 13.3893 17.9167 15.0001Z"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.9 10.7794H12.1M6.5 13.5L9.49019 7.10802C9.65215 6.76181 9.73313 6.5887 9.84535 6.535C9.94286 6.48833 10.0571 6.48833 10.1547 6.535C10.2669 6.5887 10.3478 6.76181 10.5098 7.10802L12.2273 10.7794"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

TextIllegalIcon.displayName = 'TextIllegalIcon';